import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { PATH_LOGIN } from '../constants';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const loginPath = PATH_LOGIN;

  if (authService.isLoggedIn()) {
    // Redirige al dashboard si intenta acceder a login o recover estando logueado
    if (state.url === loginPath) {
      router.navigate(['/dashboard']);
      return false;
    }
    return true;
  } else {
    // Permite el acceso a login y recover si no está logueado
    if (state.url === loginPath) {
      return true;
    }
    // Redirige a login por defecto si intenta acceder a otras rutas
    router.navigate([loginPath]);
    return false;
  }
};

